'use strict';

angular.module('cgmemApp')
	.factory('CheckIn', function ($rootScope, $http, $log) {

		var checkIns = [];
		var activeCheckIns = [];

		$http.get('/api/checkins')
			.then(function (r) {
				angular.copy(r.data, checkIns);
				angular.copy(checkIns.filter(c => !c.checkOutDate), activeCheckIns);
			})
			.catch(function (err) {
				$rootScope.$emit('generalAlert', 'Error getting checkins:', err);
			});

		$rootScope.$on('socket:checkedIn', function (ev, newCI) {
			checkIns.unshift(newCI);
			activeCheckIns.unshift(newCI);
		});

		$rootScope.$on('socket:checkedOut', function (ev, updatedCI) {
			let r = checkIns.find(c => c._id === updatedCI._id);
			if (r)
				r.checkOutDate = updatedCI.checkOutDate;
			let ai = activeCheckIns.findIndex(c => c._id === updatedCI._id);
			if (ai > -1)
				activeCheckIns.splice(ai, 1);
		});

		const get = () => checkIns;
		const getActive =  () => activeCheckIns;

		const checkIn = cis => {
			$http.post('/api/checkins/batchcheckin', cis)
			.catch(err => $rootScope.$emit('generalAlert', "Error saving checkin: " + err.messsage));
		}

		const checkOut = ids => {
			$http.post('/api/checkins/batchcheckout', ids.map(id => ({_id: id}) ))
			.catch(function (err) {
				$rootScope.$emit('generalAlert', 'Error performing checkout', err.message);
			});
		}

		const checkOutAll = () => {
			$http.post('/api/checkins/batchcheckout', activeCheckIns.map(ci => ({_id: ci._id}) ))
			.catch(function (err) {
				$rootScope.$emit('generalAlert', 'Error performing checkout', err.message);
			});
		}

		return { get, getActive, checkIn, checkOut, checkOutAll };
	});
